/* global document */

import Cookies from 'js-cookie';

export const axiosHeader = () => ({
  headers: {
    Authorization: Cookies.get(`customerToken`),
    Pragma: 'no-cache',
    tenant: getTenantId()
  }
});

export const publicAxiosHeader = () => {
  if (Cookies.get(`customerToken`)) {
    return axiosHeader();
  }
  return {
    headers: { Pragma: 'no-cache', tenant: getTenantId() }
  };
};

export const getV1RootUrl = () => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return 'https://api.commerce7.com/v1';
    case 'frontend':
      return 'https://api.commerce7.com/v1';
    default:
      return 'http://localhost:3000/v1';
  }
};

export const getGlobalRootUrl = () => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return 'https://global-api.commerce7.com/v1';
    case 'frontend':
      return 'https://global-api.commerce7.com/v1';
    case 'ngrok':
      return 'https://api-global.development.commerce7.ngrok.io/v1';
    case 'docker':
      return 'http://api-global:3000/v1';
    default:
      return 'http://localhost:3001/v1';
  }
};

export const getTenantId = () => {
  const scriptTag = document.getElementById('c7-javascript');
  const tenantId = scriptTag.getAttribute('data-tenant');
  return tenantId;
};

export const getRouterType = () => {
  const scriptTag = document.getElementById('c7-javascript');
  const router = scriptTag.getAttribute('data-router');
  if (router && router === 'hash') {
    return 'hash';
  }
  return 'browser';
};
